export default __webpack_public_path__ + "static/media/pathway.0b3f7c8f.png";